import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Docs-Root-Page max-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IndexPage = _resolveComponent("IndexPage")!
  const _component_MDXProvider = _resolveComponent("MDXProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MDXProvider, { components: _ctx.MDX_COMPONENTS }, {
      default: _withCtx(() => [
        _createVNode(_component_IndexPage)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["components"])
  ]))
}